var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timeline-tag-list"},[_c('blogpost-tag',{attrs:{"active":_vm.currentId===''}},[_vm._v("全部")]),_vm._l((_vm.tagList),function(item){return [_c('blogpost-tag',{key:item.id,attrs:{"id":item.id,"active":item.id===_vm.currentId}},[_vm._v(_vm._s(item.description)+" ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }